// Add class to body when resizing the viewport
export function resizing() {
  const body = document.body;

  if (!body.classList.contains("resizing")) {
    body.classList.add("resizing");

    setTimeout(() => {
      body.classList.remove("resizing");
    }, 1000);
  }
}
